import { PaymentFieldType } from '@endeavour/payment-integration';
import { PaymentField, BankAccountType, WithdrawalPixKeyType } from '../method.interface.js';

const bankFields = [
    {
        type: PaymentFieldType.TEXT,
        name: PaymentField.BANK_BRANCH,
        key: PaymentField.BANK_BRANCH,
    },
    {
        type: PaymentFieldType.TEXT,
        name: PaymentField.BANK_ACCOUNT,
        key: PaymentField.BANK_ACCOUNT,
    },
    {
        type: PaymentFieldType.SELECT,
        name: PaymentField.BANK_ACCOUNT_TYPE,
        key: PaymentField.BANK_ACCOUNT_TYPE,
        options: [
            {
                value: BankAccountType.PERSONAL,
                name: 'Personal',
            },
            {
                value: BankAccountType.SAVINGS,
                name: 'Savings',
            },
        ],
    },
];
function getWithdrawalForm(bankList) {
    const bankCodeField = {
        type: PaymentFieldType.SELECT,
        name: PaymentField.BANK_CODE,
        key: PaymentField.BANK_CODE,
        options: bankList.map(({ id, name }) => {
            return {
                value: id,
                name,
            };
        }),
    };
    return [
        {
            type: PaymentFieldType.SELECT,
            name: PaymentField.PIX_KEY_TYPE,
            key: PaymentField.PIX_KEY_TYPE,
            options: [
                {
                    value: WithdrawalPixKeyType.CPF,
                    name: 'PIX',
                },
                {
                    value: WithdrawalPixKeyType.EMAIL,
                    name: 'Email',
                },
                {
                    value: WithdrawalPixKeyType.TELEPHONE,
                    name: 'Telephone',
                },
                {
                    value: WithdrawalPixKeyType.BANK_DETAILS,
                    name: 'Bank Details',
                },
            ],
        },
        bankCodeField,
        ...bankFields.map((field) => {
            return {
                ...field,
                isVisible: (formData) => {
                    return (formData?.[PaymentField.PIX_KEY_TYPE] === WithdrawalPixKeyType.BANK_DETAILS);
                },
            };
        }),
    ];
}

export { getWithdrawalForm };
